import urls from '../../urls';
import contactCreate from '../_contact-create-store';


function initialState() {
    return {
        error: undefined,
    }
}


export default {
    namespaced: true,
    state: initialState(),
    mutations: {
        resetState(state) {
            Object.assign(state, initialState());
        },
        setError(state, error) {
            state.error = error;
        }
    },
    modules: {
        contactCreate
    },
};
